export default "__VITE_ASSET__2f792328__"